import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Tooltip from '../Tooltip';
import copyToClipboard from '../../utils/copyToClipboard';
import './module.css';

class Clipboard extends Component {
  static copy(textToCopy) {
    return () => copyToClipboard(textToCopy);
  }
  renderHelpAndLabel() {
    const { label, helpMessage } = this.props;
    if (!label && !helpMessage) {
      return null;
    }
    return (
      <div styleName="label">
        {label && <label htmlFor="clipboard-text">{label}</label>}
        {helpMessage && (
          <Tooltip title={helpMessage} placement="bottom">
            <span className="custom-icon custom-icon-circle custom-icon-small custom-icon-dark">
              ?
            </span>
          </Tooltip>
        )}
      </div>
    );
  }
  render() {
    const { text } = this.props;
    return (
      <div styleName="clipboard">
        {this.renderHelpAndLabel()}
        <div styleName="text-input" className="input-group">
          <input
            name="clipboard-text"
            className="form-control input-sm"
            type="text"
            value={text}
            readOnly
          />
          <Tooltip title="Copy to clipboard" placement="top">
            <Button
              styleName="copy-button"
              bsPrefix="btn btn-default btn-sm"
              onClick={Clipboard.copy(text)}
            >
              <span className="icon-budicon-669" />
            </Button>
          </Tooltip>
        </div>
      </div>
    );
  }
}

Clipboard.propTypes = {
  text: PropTypes.string.isRequired,
  label: PropTypes.string,
  helpMessage: PropTypes.string
};

export default Clipboard;
